export class GetSelectedUserDataEntity {
    userId;
    scopesIds;

    constructor(userId, scopesIds) {
      this.userId = userId;
      this.scopesIds = scopesIds;
    }
  }


